<template>
  <div class="history">
    <div class="history-content">
      <timeline timeline-theme="#05386b" timeline-bg="#05386b">
        <timeline-title>历史沿革</timeline-title>
        <timeline-item
          line-color="rgb(92, 48, 125)"
          bg-color="rgb(92, 48, 125)"
          icon-size="large"
          v-for="(item, index) in history"
          v-bind:key="index"
        >
          {{ item.date }}<br />
          <span>{{ item.desc }}</span>
          <br />
          <div v-if="item.image"><img :src="item.image" width="66%" /></div>
        </timeline-item>
      </timeline>
    </div>
  </div>
</template>
<script>
import { Timeline, TimelineItem, TimelineTitle } from "vue-cute-timeline";

export default {
  data: function () {
    return {
      history: [],
    };
  },
  created: function () {
    this.get_history();
  },
  methods: {
    get_history: function () {
      let url = "about/history?ordering=-index";
      this.$http.get(url).then((response) => {
        this.history = response.data;
      });
    },
  },
  components: {
    Timeline,
    TimelineItem,
    TimelineTitle,
  },
};
</script>
<style lang="scss" scoped>
.history {
  padding-top: 20px;
  padding-bottom: 20px;
  span {
    color: #565656;
    font-size: 16px;
  }
  .history-content {
    float: left;
    width: 950px;
    margin: 0;
    padding-left: 20px;
    img {
      margin-top: 20px;
      box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.19),
        0 10px 15px 0 rgba(0, 0, 0, 0.15);
    }
    .timeline-item {
      font-size: 16px;
      font-weight: bold;
      padding-bottom: 20px;
      border-bottom: none;
    }
    .timeline-title {
      font-size: 20px;
      font-weight: bold;
      color: #931b22 !important;
    }
  }
}
</style>
